import React from 'react';
import ExpansionPanel from 'emerald-ui/lib/ExpansionPanel';
import Button from 'emerald-ui/lib/Button';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: ExpansionPanel, componentName: 'ExpansionPanel' }], 'ExpansionPanel'),
  description: (
    <span>
      A panel that has a summary of information that shows when clicked. This should be used mainly to edit small
      amounts of data. For the summary content use <span className="code">ExpansionPanel.Summary</span>, for an
      alternative summary (summary content that appears when the Panel is expanded) use{' '}
      <span className="code">ExpansionPanel.AlternativeSummary</span> and for the content that expands use{' '}
      <span className="code">ExpansionPanel.Content</span>.
    </span>
  ),
  codeSamples: [
    {
      title: 'Alternative summary',
      scope: { ExpansionPanel, Button },
      code: `<div>
  <ExpansionPanel>
    <ExpansionPanel.Summary>
      <p style={{ margin: 0, textAlign: 'center' }}>Show more</p>
    </ExpansionPanel.Summary>
    <ExpansionPanel.AlternativeSummary>
      <p style={{ margin: 0, textAlign: 'center' }}>Show less</p>
    </ExpansionPanel.AlternativeSummary>
    <ExpansionPanel.Content>
      <h1>This is a heading</h1>
      <p>This is a paragraph</p>
      <Button color="info">Don&#39;t click me!</Button>
    </ExpansionPanel.Content>
  </ExpansionPanel>
</div>`,
    },
  ],
};
